export default __webpack_public_path__ + "static/media/vader.3a0ad9f3.svg";